
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { components } from "react-select";
import { getBrands, getCountries, getModels, getVersions } from '../services';
import { context, staticUrl } from '../utils';
import MultiSelectInline, { formatOptionLabelWithImage } from './MultiSelectInline';

export const NoOptionsMessage = props => {
    const { t } = useTranslation();
    return (
        <components.NoOptionsMessage {...props}>
            {t("No options")}
        </components.NoOptionsMessage>
    );
};

export const modelToOption = x => {
    return {
        value: x.id,
        // label: <div style={{ alignItems: "center", display: "flex" }}>
        //     <span style={{ width: "50px", height: "50px", display: "inline-block", textAlign: "center", border: "1px solid hsl(0, 0%, 80%)", marginRight: "10px", backgroundColor: "white", "overflow": "hidden", padding: "1px" }}>
        //         <img src={x.main_image_url} style={{ height: "100%", maxHeight: "50px" }} /></span>
        //     {x.name}
        // </div>,
        label: x.name,
        name: x.name,
        image: x.main_image_url,
        id: x.id,
        components_url: x.components_url,
    };
};


const SelectorStyles = {
    control: (base) => ({
        ...base,
        // minHeight: 50,
        cursor: 'pointer',
        marginBottom: "10px",
    }),
    option: (styles, state) => ({
        ...styles,
        cursor: 'pointer',
    }),
};

export const BrandSelector = props => {
    const { t } = useTranslation();
    const [brands, setBrands] = useState([]);

    useEffect(() => {

        async function handle() {
            const data = await getBrands();
            setBrands(data.results);
        }

        handle();
    }, []);

    const options = brands.map(x => {
        return {
            id: x.id,
            value: x.id,
            label: x.name,
            name: x.name,
        };
    });

    return <MySelect
        options={options}
        placeholder={t('Choose Brand')}
        {...props}
    />;
};


export const ModelSelector = ({ brandId, ...rest }) => {

    const { t } = useTranslation();
    const [models, setModels] = useState([]);

    useEffect(() => {
        if (!brandId) {
            setModels([]);
            return;
        }
        async function handle() {
            const data = await getModels({ brand: brandId, page_size: 100 });
            setModels(data.results);
        }

        handle();
    }, [brandId]);

    const options = models.map(modelToOption);

    return <MySelect
        options={options}
        placeholder={t('Choose Model') + "..."}
        {...rest}
    />;
};


export const VersionSelector = ({ modelId, ...rest }) => {
    const { t } = useTranslation();
    const [models, setModels] = useState([]);
    useEffect(() => {

        async function handle() {
            if (!modelId) {
                setModels([]);
                return;
            }
            const data = await getVersions({ modelId });
            setModels(data.results);
        }

        handle();
    }, [modelId]);


    const options = models.map(x => {
        return {
            value: x.id,
            label: x.diameter,
            name: x.name,
            id: x.id,
        };
    });

    return <MySelect
        options={options}
        placeholder={t('Choose Version') + "..."}
        {...rest}
    />;
};


export const getQuoteUrl = model => {
    return `${context.urls.quote}?id=${model.id}`;
};


export const CountrySelector = (props) => {
    const [countries, setCountries] = useState([]);

    const { t } = useTranslation();
    useEffect(() => {

        async function handle() {
            const data = await getCountries();
            setCountries(data);
        }
        handle();
    }, []);


    const options = Object.entries(countries).map(x => {
        return {
            value: x[0],
            label: x[1],
        };
    });

    return <div>
        <MySelect
            options={options}
            placeholder={t('Select country...')}
            {...props}
        />
    </div >;
};


export const YearSelector = (props) => {
    const options = range(1950, new Date().getFullYear()).reverse().map(x => {
        return {
            value: x,
            label: x,
        };
    });

    return <div>
        <MySelect
            options={options}
            {...props}
        />
    </div >;
};

export const YearRangeSelector = props => (
    <FeatureSelector
        options={context.implant_features.year_range}
        {...props} />
);


export const ConnectionShapeSelector = props => (
    <FeatureSelector
        options={context.implant_features.connection_shape}
        {...props} />
);


export const ScrewdriverShapeSelector = props => (
    <FeatureSelector
        options={context.implant_features.screwdriver_shape}
        {...props} />
);
export const FeatureSelector = (props) => {

    var rawOptions = props.options;

    if (!rawOptions && props.feature) {
        rawOptions = context.implant_features[props.feature];
    }

    const options = rawOptions.map(x => ({
        value: x.value,
        label: x.name,
        image: x.image ? (staticUrl + "img/" + x.image) : '',
    }
    ));

    return <MySelect
        {...props}
        options={options}
    />;
};


const range = (min, max) => [...Array(max - min + 1).keys()].map(i => i + min);


const MySelectorStyles = {
    control: (base) => ({
        ...base,
        cursor: 'pointer',
        marginBottom: "10px",
        //height: 38
    }),
    option: (styles, state) => ({
        ...styles,
        cursor: 'pointer',
    }),

};

const MySelect = (props) => {
    const ref = useRef(null);
    const { t } = useTranslation();
    // const options = props.options && props.options.map(x => x.image).some(Boolean) ? props.options.map(x => ({
    //     ...x,
    // })) : props.options;

    const options = props.options;

    const hasImages = props.options && props.options.map(x => x.image).some(Boolean);
    let val;
    if (props.isMulti) {
        val = options.filter(x => (props.value || []).includes(x.value)) || null;
    } else {
        const selectedValue = props.value && props.value.value ? props.value.value : props.value;
        val = options.filter(x => selectedValue === x.value)[0] || null;
    }

    const onChange = (option) => {
        props.onChange(option);
    };



    useEffect(() => {

        if (props.isFocused) {
            console.log('changed to is focused !');
            ref.current.focus();
        }
    }, [props.isFocused]);

    const placeholder = props.placeholder || (t('Choose') + '...');
    if (props.isMulti) {
        return <MultiSelectInline
            {...props}
            value={val}
            options={options}
            classNamePrefix="myselect"
            onChange={onChange}
            isClearable={true}
            placeholder={placeholder}
            components={{ NoOptionsMessage }}
            styles={MySelectorStyles}
            hasImages={hasImages}
        />;
    }

    return <Select
        ref={ref}
        {...props}
        value={val}
        options={options}
        classNamePrefix="myselect"
        onChange={onChange}
        isClearable={true}
        placeholder={placeholder}
        components={{ NoOptionsMessage }}
        styles={MySelectorStyles}

        formatOptionLabel={hasImages ? formatOptionLabelWithImage : null}
    />;
};

const getLabelWithImage = item => <div className="myselect-label-container">
    <span className="myselect-label-image" style={!item.image ? { backgroundColor: "#f6f7f9" } : {}}>
        {item.image ? <img src={item.image} style={{ height: "100%", maxHeight: "50px" }} /> : ''}
    </span>
    {item.label}
</div>;